// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardAccumulatorModel {
    static getAttributeTypeMap() {
        return CardAccumulatorModel.attributeTypeMap;
    }
}
CardAccumulatorModel.discriminator = undefined;
CardAccumulatorModel.attributeTypeMap = [
    {
        "name": "medications",
        "baseName": "medications",
        "type": "Array<CardMedicationModel>"
    },
    {
        "name": "medicationMaxBenefit",
        "baseName": "medicationMaxBenefit",
        "type": "number"
    },
    {
        "name": "remainingMedicationBenefit",
        "baseName": "remainingMedicationBenefit",
        "type": "number"
    },
    {
        "name": "totalMedicationPaid",
        "baseName": "totalMedicationPaid",
        "type": "number"
    }
];
//# sourceMappingURL=cardAccumulatorModel.js.map